module.exports = __webpack_public_path__ + "img/cam_1_off.6f193e97.png";